<div class="debt-detail-container">
    <h1>{{isEdit == true ? 'Update a debt' : 'Add a debt'}}</h1>
    <div *ngIf="loading == true">
        <h2>Loading data...</h2>
    </div>
    <div *ngIf="loading == false">
        <form [formGroup]="debtForm" fxLayout="column">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput formControlName="debtNameCtl">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Term (Months)</mat-label>
                <input matInput type="number" formControlName="debtMonthsCtl">
            </mat-form-field>
            <mat-form-field floatLabel="always">
                <mat-label>Borrwed</mat-label>
                <input matInput type="number" class="new-purchase-guide-right-align" formControlName="debtBorrowedCtl">
                <span matTextPrefix>$&nbsp;</span>
                <span matTextSuffix>.00</span>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Paid Out</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="debtBorrwedAtCtl">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-checkbox formControlName="debtIsExploratoryCtl">Just exploring</mat-checkbox>
            <div fxLayout="row" fxLayoutAlign="center">
                <button mat-raised-button color="accent" (click)="onCancel()" [disabled]="saving">{{ this.debtForm.dirty
                    ? 'Cancel' : 'Back'}}</button>&nbsp;
                <button mat-raised-button color="primary" (click)="onSave()" [class.spinner]="saving"
                    [disabled]="!debtForm.valid || saving || deleting">{{saving ? 'Saving...' : 'Save'}}</button>&nbsp;
                <button mat-raised-button color="warn" (click)="onDelete()" [class.spinner]="deleting"
                    [disabled]="saving || deleting" *ngIf="isEdit == true">{{deleting ? 'Deleting...':
                    'Delete'}}</button>&nbsp;
            </div>
        </form>
        <div *ngIf="isEdit === true">
            <h2>Instruments</h2>
            <div *ngIf="loadingInstruments === true">
                Loading instruments...
            </div>
            <div *ngIf="loadingInstruments === false">
                <div *ngIf="instruments.length == 0">
                    No instruments attached to this debt
                </div>
                <table mat-table [dataSource]="instruments" *ngIf="instruments.length > 0">
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>Type</th>
                        <td mat-cell *matCellDef="let element">{{element.InstrumentType | titlecase}}</td>
                    </ng-container>
                    <ng-container matColumnDef="term">
                        <th mat-header-cell *matHeaderCellDef>Term (Months)</th>
                        <td mat-cell *matCellDef="let element">
                        <div *ngIf="(element.ForecastSchedules && element.ForecastSchedules[0] && element.ForecastSchedules[0].NumberOfPayments)">
                            {{element.ForecastSchedules[0].NumberOfPayments  | amDuration:'months'}}
                        </div>
                        <div *ngIf="!(element.ForecastSchedules && element.ForecastSchedules[0] && element.ForecastSchedules[0].NumberOfPayments)">
                            {{element.NotionalTermMonths | amDuration:'months'}}
                        </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="allocation">
                        <th mat-header-cell *matHeaderCellDef>Allocation</th>
                        <td mat-cell *matCellDef="let element">
                            {{element.PrincipalAmount | currency}} ({{element.PrincipalPercent | percent: '1.0-2'}})
                    </ng-container>
                    <ng-container matColumnDef="rate">
                        <th mat-header-cell *matHeaderCellDef>Rate</th>
                        <td mat-cell *matCellDef="let element">{{(element.FixedRate / 100.0) | percent: '1.0-2'}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="instrumentsDisplayColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: instrumentsDisplayColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
</div>